module.exports = __webpack_public_path__ + "components/media-kit/static/whiteroom-desktop-3e4c0d86e708fc2cf29d19b5bf956dc6.png";